"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypesService = void 0;
class TypesService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * expose the timeline types
     * @param requestBody
     * @returns any Successful response
     * @throws ApiError
     */
    exposeTimelineTypes(requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
exports.TypesService = TypesService;
